import {
  containerLengthBayMappingsApi,
  ContainerLengthBayMappingDto,
  CreateContainerLengthBayMappingDto,
  UpdateContainerLengthBayMappingDto,
} from '@yard/app/api/dg-config-api'
import { computed, makeObservable, observable, runInAction } from 'mobx'

export class ContainerLengthBayMappingStore {
  data = new Map<string, ContainerLengthBayMappingDto>()

  constructor() {
    makeObservable(this, {
      data: observable,
      entries: computed,
    })
  }

  get entries(): ContainerLengthBayMappingDto[] {
    return Array.from(this.data.values()).sort((a, b) => a.length - b.length)
  }

  getById(id: string): ContainerLengthBayMappingDto | undefined {
    return this.data.get(id)
  }

  private setAll(entities: ContainerLengthBayMappingDto[]): void {
    runInAction(() => {
      this.data = new Map(entities.map(item => [item.id, item]))
    })
  }

  async loadAll(): Promise<void> {
    const mappings = await containerLengthBayMappingsApi.getAll()
    this.setAll(mappings)
  }

  async create(dto: CreateContainerLengthBayMappingDto): Promise<void> {
    await containerLengthBayMappingsApi.create(dto)
  }

  async update(id: string, dto: UpdateContainerLengthBayMappingDto): Promise<void> {
    await containerLengthBayMappingsApi.update(id, dto)
  }

  async delete(id: string): Promise<void> {
    await containerLengthBayMappingsApi.delete(id)
  }
}
